import { createContext, ReactNode, useState } from "react";
import { useLocalStorage } from "../helpers/useLocalStorage";
import { useIsMobile } from "../device/useIsMobile";
import { useAnalytics } from "../firebase/firebase";

interface ISettings {
    questionHeight: number;
    setQuestionHeight: (b: number) => void;
    // showFaulty: boolean;
    // setShowFaulty: (b: boolean) => void;
    columnsOverride: number;
    setColumnsOverride: (n: number) => void;
    publishPdfMode: "combined" | "separate";
    setPublishPdfMode: (m: string) => void;
    imageScale: number;
    setImageScale: (s: number) => void;
}

interface SettingsProviderProps {
    children: ReactNode;
}

export const SettingsContext = createContext<ISettings | undefined>(undefined);

export const SettingsProvider = (props: SettingsProviderProps) => {
    const { track } = useAnalytics();
    const [questionHeight, setQuestionHeight] = useLocalStorage<number>("settings.questionheight", 75);
    // const [showFaultyValue, setShowFaultyValue] = useLocalStorage<boolean>("settings.showfaulty", false);
    const [columnsOverride, setColumnsOverride] = useLocalStorage<number>("settings.columnsoverride", 0);
    const [publishPdfMode, setPublishPdfMode] = useLocalStorage<"combined" | "separate">("settings.publishpdfmode", "combined");
    const isMobile = useIsMobile();
    const [imageScale, setImageScale] = useLocalStorage<number>("settings.imageScale", isMobile ? 0.4 : 0.6);

    return (
        <SettingsContext value={{
            questionHeight,
            // showFaulty: showFaultyValue,
            publishPdfMode,
            imageScale,
            setQuestionHeight: (value: number) => {
                setQuestionHeight(value);
                track("settings.questionHeight.update", { value: value });
            },
            // setShowFaulty: (value: boolean) => {
            //     setShowFaultyValue(value);
            //     track("settings.showFaulty.update", { value: value });
            // },
            columnsOverride,
            setColumnsOverride: (value: number) => {
                setColumnsOverride(value);
                track("settings.columns.update", { value: value });
            },
            setPublishPdfMode: (s: string) => {
                if (s == "combined") {
                    setPublishPdfMode("combined")
                }
                if (s == "separate") {
                    setPublishPdfMode("separate")
                }
                track("settings.pdfDownload.update", { value: s });
            },
            setImageScale: (value: number) => {
                setImageScale(value);
                track("settings.magnification.update", { value: value });
            },
        }}>
            {props.children}
        </SettingsContext>
    )

}